import { render, staticRenderFns } from "./cash-reg.vue?vue&type=template&id=45345399&scoped=true&"
import script from "./cash-reg.vue?vue&type=script&lang=js&"
export * from "./cash-reg.vue?vue&type=script&lang=js&"
import style0 from "./cash-reg.vue?vue&type=style&index=0&id=45345399&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45345399",
  null
  
)

export default component.exports